import { render } from "./wNumber.vue?vue&type=template&id=faea2634&ts=true"
import script from "./wNumber.vue?vue&type=script&lang=ts"
export * from "./wNumber.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__